import React from "react";
import { connect } from "react-redux";

import Retailers from "./Retailers";

const RetailersContainer = props => {
  return <Retailers {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(RetailersContainer);



// WEBPACK FOOTER //
// src/containers/metier/referential/Retailers.container.js